module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "2577");
/******/ })
/************************************************************************/
/******/ ({

/***/ "0ffc":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "1749":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_css_loader_dist_cjs_js_ref_7_oneOf_1_1_vue_loader_lib_loaders_stylePostLoader_js_postcss_loader_src_index_js_ref_7_oneOf_1_2_vue_multi_select_css_vue_type_style_index_0_id_7ff43ffe_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("902b");
/* harmony import */ var _mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_css_loader_dist_cjs_js_ref_7_oneOf_1_1_vue_loader_lib_loaders_stylePostLoader_js_postcss_loader_src_index_js_ref_7_oneOf_1_2_vue_multi_select_css_vue_type_style_index_0_id_7ff43ffe_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_css_loader_dist_cjs_js_ref_7_oneOf_1_1_vue_loader_lib_loaders_stylePostLoader_js_postcss_loader_src_index_js_ref_7_oneOf_1_2_vue_multi_select_css_vue_type_style_index_0_id_7ff43ffe_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "2577":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ../@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("0ffc")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ../cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"025c84ce-vue-loader-template"}!../vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../cache-loader/dist/cjs.js??ref--1-0!../vue-loader/lib??vue-loader-options!./src/components/vueMultiSelect/vue-multi-select.vue?vue&type=template&id=7ff43ffe&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select"},[_c('button',{ref:"buttonClick",class:("btn-select " + _vm.btnClass),attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.toggleCheckboxes}},[_c('div',{staticClass:"buttonLabel"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.getBtnLabel)}}),_c('span',{staticClass:"caret"})])]),_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.externalClick),expression:"externalClick"}],staticClass:"checkboxLayer",class:((_vm.isOpen ? 'show' : '') + " " + _vm.popoverClass),style:(_vm.getPosition)},[_c('div',{staticClass:"helperContainer"},[_c('div',{staticClass:"line"},[_vm._l((_vm.getButtonList),function(button,index){return _c('button',{key:index,staticClass:"helperButton",attrs:{"type":"button"},on:{"click":function($event){return _vm.selectCurrent(button)}}},[_vm._v(" "+_vm._s(button.selectAll ? button.nameNotAll : button.nameAll)+" ")])}),(_vm.historyButton && _vm.previousSelected.length)?_c('button',{staticClass:"historyButton",on:{"click":_vm.historyBack}},[_vm._v(" "+_vm._s(_vm.historyButtonText)+" ")]):_vm._e()],2),(_vm.search)?_c('div',{staticClass:"line",staticStyle:{"position":"relative"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],staticClass:"inputFilter",attrs:{"placeholder":_vm.searchPlaceholder,"emptyTabText":_vm.emptyTabText,"type":"text"},domProps:{"value":(_vm.searchInput)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value},function($event){return _vm.searchfn()}]}}),_c('button',{staticClass:"clearButton",attrs:{"type":"button"},on:{"click":function($event){return _vm.clearSearch()}}},[_vm._v("× ")])]):_vm._e()]),(_vm.groups === true)?_c('div',[_c('ul',{staticClass:"tab tab-block"},_vm._l((_vm.globalModel),function(tab,index){return _c('li',{directives:[{name:"show",rawName:"v-show",value:(tab[_vm.list].length),expression:"tab[list].length"}],key:index,staticClass:"tab-item",class:{active : _vm.idSelectedTab == index},on:{"click":function($event){return _vm.selectTab(index)}}},[_c('span',{staticClass:"pointer"},[_vm._v(_vm._s(tab[_vm.groupName]))])])}),0)]):_vm._e(),_c('div',{staticClass:"checkBoxContainer"},[_vm._l((_vm.globalModel),function(tab,index){return _c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.idSelectedTab == index),expression:"idSelectedTab == index"}],key:index,staticClass:"selectList"},_vm._l((tab[_vm.list]),function(option,indexOptions){return _c('li',{directives:[{name:"show",rawName:"v-show",value:(option.visible),expression:"option.visible"}],key:indexOptions,class:[option[_vm.labelName].includes('Parent-')  ? 'disabled' : '', 'selectItem'],style:(_vm.cssSelected(option)),on:{"click":function($event){return _vm.selectOption(option, tab[_vm.list])}}},[_vm._t("option",function(){return [(option[_vm.labelSelected])?_c('span',{staticClass:"right margin-right-10"},[_vm._v("✓")]):_vm._e(),_c('span',{staticClass:"margin-left-20"},[_vm._v(_vm._s(option[_vm.labelName].split('Parent-').pop()))])]},{"option":option})],2)}),0)}),(!_vm.valueSelected  || _vm.optionsAllHide)?_c('div',{staticClass:"empty-tab"},[_vm._v(_vm._s(_vm.emptyTabText))]):_vm._e()],2)])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/vueMultiSelect/vue-multi-select.vue?vue&type=template&id=7ff43ffe&scoped=true&

// CONCATENATED MODULE: ./src/helper/equals.js
/* harmony default export */ var equals = ({
  compareArrayObject(value1, value2, key) {
    if (value1.length !== value2.length) return false;
    for (let i = 0; i < value1.length; i += 1) {
      if (value1[i][key] !== value2[i][key]) {
        return false;
      }
    }
    return true;
  },
  compareSimpleArray(value1, value2) {
    if (value1.length !== value2.length) return false;
    for (let i = 0; i < value1.length; i += 1) {
      if (value1[i] !== value2[i]) {
        return false;
      }
    }
    return true;
  },
});

// CONCATENATED MODULE: ./src/components/vueMultiSelect/vue-multi-select.js?vue&type=script&lang=js&


/* harmony default export */ var vue_multi_selectvue_type_script_lang_js_ = ({
  name: 'multi-select',
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
    filters: {
      type: Array,
      default: () => [],
    },
    selectOptions: {
      type: Array,
      default: () => [],
    },
    eventName: {
      type: String,
      default: 'selectionChanged',
    },
    reloadInit: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => ([]),
    },
    btnClass: {
      type: String,
      default: '',
    },
    popoverClass: {
      type: String,
      default: '',
    },
    btnLabel: {
      type: Function,
      default: () => ('multi-select'),
    },
    search: {
      type: Boolean,
      default: false,
    },
    searchPlaceholder: {
      type: String,
      default: 'Search...',
    },
    historyButton: {
      type: Boolean,
      default: false,
    },
    historyButtonText: {
      type: String,
      default: '↶',
    },
    position: {
      type: String,
      default: 'bottom-left',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledUnSelect: {
      type: Boolean,
      default: false,
    },
    emptyTabText: {
      type: String,
      default: 'No Data',
    },
  },
  data() {
    return {
      valueSelected: [],
      simpleArray: false,
      multiSelect: null,
      groups: null,
      isOpen: false,
      globalModel: [],
      idSelectedTab: 0,
      searchInput: '',
      optionsAllHide: false,
      previousSelected: [],
    };
  },
  created() {
    this.setConfig();
  },
  methods: {
    openMultiSelect() {
      this.manualClick = true;
      this.isOpen = true;
      this.openStatus(this.isOpen);
    },
    closeMultiSelect() {
      this.manualClick = true;
      this.isOpen = false;
      this.openStatus(this.isOpen);
    },
    setConfig() {
      this.multi = typeof (this.options.multi) !== 'undefined'
        ? this.options.multi : false;
      this.groups = typeof (this.options.groups) !== 'undefined'
        ? this.options.groups : false;
      this.list = this.options.labelList || 'list';
      this.labelName = this.options.labelName || 'name';
      this.labelValue = this.options.labelValue || this.labelName;
      this.groupName = this.options.groupName || 'name';
      this.labelSelected = this.options.labelSelected || 'selected';
      this.labelDisabled = this.options.labelDisabled || 'disabled';
      this.cssSelected = this.options.cssSelected || (
        (option) => (option[this.labelSelected]
          ? {
            'font-weight': 'bold',
            color: '#5755d9',
          } : ''));
      this.init();
    },
    init() {
      const clone = this.cloneData(this.selectOptions);
      if (!this.groups) {
        if (typeof this.selectOptions[0] === 'string'
          || typeof this.selectOptions[0] === 'number') {
          this.simpleArray = true;
          this.globalModel = [{ [this.list]: this.prepareArray(clone) }];
        } else {
          this.globalModel = [{ [this.list]: clone }];
        }
      } else {
        if (typeof clone[0][this.list][0] === 'string'
        || typeof clone[0][this.list][0] === 'number') {
          for (let i = 0; i < clone.length; i += 1) {
            clone[i][this.list] = this.prepareArray(clone[i][this.list]);
          }
          this.simpleArray = true;
        }
        this.globalModel = clone;
      }
      this.initValues();
    },
    initValues() {
      this.valueSelected = [];
      for (let i = 0; i < this.globalModel.length; i += 1) {
        for (let j = 0; j < this.globalModel[i][this.list].length; j += 1) {
          if (typeof this.globalModel[i][this.list][j][this.labelSelected]
            === 'boolean') {
            this.globalModel[i][this.list][j][this.labelSelected] = false;
          } else {
            this.$set(this.globalModel[i][this.list][j], this.labelSelected, false);
            this.$set(this.globalModel[i][this.list][j], 'visible', true);
          }
          for (let k = 0; k < this.value.length; k += 1) {
            if (this.simpleArray
              && this.globalModel[i][this.list][j][this.labelValue] === this.value[k]) {
              this.globalModel[i][this.list][j][this.labelSelected] = true;
              this.valueSelected.push(this.globalModel[i][
                this.list][j][this.labelValue]);
            } else if (!this.simpleArray
              && this.globalModel[i][this.list][j][this.labelValue]
              === this.value[k][this.labelValue]) {
              this.globalModel[i][this.list][j][this.labelSelected] = true;
              const opt = { ...this.globalModel[i][this.list][j] };
              delete opt[this.labelSelected];
              delete opt.visible;
              this.valueSelected.push(opt);
            }
          }
        }
      }
      this.filter();
      this.$emit('input', this.valueSelected.slice(0));
      this.$emit(this.eventName, this.valueSelected.slice(0));
    },
    toggleCheckboxes(event) {
      this.multiSelect = event.target;
      if (this.multiSelect.className === 'buttonLabel') {
        this.multiSelect = this.multiSelect.parentNode;
      }
      this.isOpen = !this.isOpen;
      this.openStatus(this.isOpen);
    },
    externalClick(event) {
      if (this.isOpen && !this.manualClick) {
        let elem = event.target;
        if (!!elem && elem.className === 'buttonLabel') {
          elem = elem.parentNode;
        }
        if (!!elem && elem.isSameNode(this.multiSelect)) {
          return;
        }
        this.isOpen = false;
        this.openStatus(this.isOpen);
      }
      this.manualClick = false;
    },
    /* eslint no-param-reassign: ["error", { "props": false }] */
    selectOption(option, list) {
      if (option[this.labelDisabled]) {
        this.pushOption(option)
        return;
      }
      if (!option[this.labelSelected]) {



        // Parent logic is always here since we always keep it as 'false' for selected.


        // Determine which are children categories by looking at the items between the two "Parent-" denoted categories
        let indexOfParent = list.findIndex((object, i) => {
          return object.name === option.name;
        });


        let indexOfNextParent = list.findIndex((object, i) => {
          return i > indexOfParent && object.name.includes('Parent-');
        });

        let childOptions = list.slice(indexOfParent + 1, indexOfNextParent);
        


        // IF PARENT 
        
        if(option.name.includes('Parent-')) {

          // First determine if all children are already selected
          console.log('val selected');
          console.log(this.valueSelected)
          let containsAllChildren = true 

          childOptions.forEach((child) => {
            if (!this.valueSelected.includes(child.name)) {
              containsAllChildren = false;
            }
          }) 


          console.log(containsAllChildren);

          // If all children are already selected, then de-select all. 
          if(containsAllChildren) {
            childOptions.forEach((option) => {
              this.previousSelected.push(this.cloneData(this.valueSelected));
              this.popOption(option);
              this.$emit('input', this.valueSelected.slice(0));
              this.$emit(this.eventName, this.valueSelected.slice(0));
              option[this.labelSelected] = false;
            })

          } else {

            // If not all already selected, do a loop and add all child categories as selected.
            childOptions.forEach((option) => {
       
              // Only add if child doesn't already exist in selected array
              if (!this.valueSelected.includes(option.name)) {

                this.previousSelected.push(this.cloneData(this.valueSelected));

                this.pushOption(option);
                this.$emit('input', this.valueSelected.slice(0));
                this.$emit(this.eventName, this.valueSelected.slice(0));
                option[this.labelSelected] = true;
              }

            })


          }

          // End custom logic. 




      
        } else {

            this.previousSelected.push(this.cloneData(this.valueSelected));
          
            if (!this.multi) {
              this.deselctAll();
              this.valueSelected = [];
              this.externalClick({ path: [] });
            }
    
    
            this.pushOption(option);
            this.$emit('input', this.valueSelected.slice(0));
            this.$emit(this.eventName, this.valueSelected.slice(0));

        }
    
        

      } else {
 
        if (!this.multi && this.disabledUnSelect) {
          return;
        }
        this.previousSelected.push(this.cloneData(this.valueSelected));
        this.popOption(option);
        this.$emit('input', this.valueSelected.slice(0));
        this.$emit(this.eventName, this.valueSelected.slice(0));


      }

      // Keep parent as always false checked.

      if (!option.name.includes('Parent-')) {
        option[this.labelSelected] = !option[this.labelSelected];
      }
      
      this.filter();
    },
    pushOption(option) {
      if (this.simpleArray) {
        this.valueSelected.push(option[this.labelValue]);
      } else {
        const opt = { ...option };
        delete opt[this.labelSelected];
        delete opt.visible;
        this.valueSelected.push(opt);
      }
    },
    popOption(opt) {
      for (let i = 0; i < this.valueSelected.length; i += 1) {
        if (this.valueSelected[i][this.labelValue] === opt[this.labelValue]
          || (this.simpleArray && this.valueSelected[i] === opt[this.labelValue])) {
          this.valueSelected.splice(i, 1);
          return;
        }
      }
    },
    selectTab(id) {
      this.idSelectedTab = id;
      this.searchfn();
    },
    searchfn() {
      let allHide = true;
      for (let i = 0; i < this.globalModel[this.idSelectedTab][this.list].length;
        i += 1) {
        if (~this.globalModel[this.idSelectedTab][this.list][i][this.labelName]
          .toLowerCase().indexOf(
            this.searchInput.toLowerCase(),
          )) {
          allHide = false;
          this.globalModel[this.idSelectedTab][this.list][i].visible = true;
        } else {
          this.globalModel[this.idSelectedTab][this.list][i].visible = false;
        }
      }
      this.optionsAllHide = allHide;
      this.filter();
    },
    clearSearch() {
      this.searchInput = '';
      this.searchfn();
    },
    selectCurrent(option) {
      this.previousSelected.push(this.cloneData(this.valueSelected));
      for (let i = 0; i < this.globalModel[this.idSelectedTab][this.list].length;
        i += 1) {
        if (this.globalModel[this.idSelectedTab][this.list][i].visible
          && !this.globalModel[this.idSelectedTab][this.list][i][this.labelDisabled]
          && option.func(this.globalModel[this.idSelectedTab][this.list][i])) {
          if (!option.selectAll) {
            if (!this.globalModel[this.idSelectedTab][this.list][i][this.labelSelected]) {
              this.globalModel[this.idSelectedTab][this.list][i][this.labelSelected] = true;
              this.pushOption(this.globalModel[this.idSelectedTab][this.list][i]);
            }
          } else if (this.globalModel[this.idSelectedTab][this.list][i][this.labelSelected]) {
            this.globalModel[this.idSelectedTab][this.list][i][this.labelSelected] = false;
            this.popOption(this.globalModel[this.idSelectedTab][this.list][i]);
          }
        }
      }
      this.$emit('input', this.valueSelected.slice(0));
      this.$emit(this.eventName, this.valueSelected.slice(0));
      option.selectAll = !option.selectAll;
      this.filter();
    },
    filter() {
      for (let i = 0; i < this.filters.length; i += 1) {
        let allSelected = true;
        for (let j = 0; j < this.globalModel[this.idSelectedTab][this.list].length;
          j += 1) {
          if (this.globalModel[this.idSelectedTab][this.list][j].visible
            && this.filters[i].func(
              this.globalModel[this.idSelectedTab][this.list][j],
            )
              && !this.globalModel[this.idSelectedTab][this.list][j][this.labelDisabled]
              && !this.globalModel[this.idSelectedTab][this.list][j][this.labelSelected]) {
            allSelected = false;
            break;
          }
        }
        this.filters[i].selectAll = allSelected;
      }
    },
    deselctAll() {
      for (let i = 0; i < this.globalModel.length; i += 1) {
        for (let j = 0; j < this.globalModel[i][this.list].length; j += 1) {
          if (!this.globalModel[i][this.list][j][this.labelDisabled]) {
            this.globalModel[i][this.list][j][this.labelSelected] = false;
          }
        }
      }
    },
    prepareArray(value) {
      return value.map((elem) => ({ [this.labelValue]: elem }));
    },
    cloneData(value) {
      if (Array.isArray(value)) {
        return value.map(this.cloneData);
      } if (value && typeof value === 'object') {
        const res = {};
        const keys = Object.keys(value);
        for (let i = 0; i < keys.length; i += 1) {
          res[keys[i]] = this.cloneData(value[keys[i]]);
        }
        return res;
      }
      return value;
    },
    historyBack() {
      const previousValues = this.previousSelected.pop();
      this.$emit('input', previousValues);
      this.$emit(this.eventName, previousValues);
    },
    openStatus(status) {
      const event = status ? 'open' : 'close';
      this.$emit(event);
    },
  },
  computed: {
    getBtnLabel() {
      return this.btnLabel(this.valueSelected);
    },
    getPosition() {
      if (this.multiSelect) {
        const btnHeight = this.multiSelect.offsetHeight;
        const positions = this.position.split('-');
        const style = {
          [positions[1]]: 0,
        };
        if (positions[0] === 'top') {
          style.bottom = `${btnHeight}px`;
        }
        return style;
      }
      return {};
    },
    getButtonList() {
      return !!this.filters && this.multi && this.filters;
    },
  },
  watch: {
    selectOptions: {
      handler() {
        this.setConfig();
      },
      deep: true,
    },
    reloadInit: {
      handler(value) {
        if (value) {
          this.initValues();
          this.$emit('vueMultiSelectInited');
        }
      },
    },
    value: {
      handler(newVal, oldval) {
        if (oldval && newVal && this.valueSelected) {
          if (this.simpleArray
            && !equals.compareSimpleArray(newVal, this.valueSelected)) {
            this.initValues();
          } else if (!equals.compareArrayObject(
            newVal, this.valueSelected, this.labelName,
          )) {
            this.initValues();
          }
        }
      },
      deep: true,
    },
  },
  directives: {
    'click-outside': {
      bind(el, binding) {
        const { bubble } = binding.modifiers;
        const ua = navigator.userAgent;
        const event = (ua.match(/iPad|iPhone/i)) ? 'touchstart' : 'click';
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.vueClickOutside = handler;
        document.addEventListener(event, handler);
      },
      unbind(el) {
        const ua = navigator.userAgent;
        const event = (ua.match(/iPad|iPhone/i)) ? 'touchstart' : 'click';
        document.removeEventListener(event, el.vueClickOutside);
        el.vueClickOutside = null;
      },
    },
  },
});

// CONCATENATED MODULE: ./src/components/vueMultiSelect/vue-multi-select.js?vue&type=script&lang=js&
 /* harmony default export */ var vueMultiSelect_vue_multi_selectvue_type_script_lang_js_ = (vue_multi_selectvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/vueMultiSelect/vue-multi-select.css?vue&type=style&index=0&id=7ff43ffe&scoped=true&lang=css&
var vue_multi_selectvue_type_style_index_0_id_7ff43ffe_scoped_true_lang_css_ = __webpack_require__("1749");

// CONCATENATED MODULE: ../vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/vueMultiSelect/vue-multi-select.vue






/* normalize component */

var component = normalizeComponent(
  vueMultiSelect_vue_multi_selectvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "7ff43ffe",
  null
  
)

/* harmony default export */ var vue_multi_select = (component.exports);
// CONCATENATED MODULE: ../@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (vue_multi_select);



/***/ }),

/***/ "902b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ })

/******/ })["default"];
//# sourceMappingURL=vue-multi-select.common.js.map